import { useTranslation } from "react-i18next";
import { FaLinkedinIn, FaGithub, FaInstagram } from "react-icons/fa";
import { Mail } from "lucide-react";
import "./Footer.css";

const SOCIAL_LINKS = [
  { href: "https://it.linkedin.com/in/youssef-bachaoui-926a061a1", Icon: FaLinkedinIn, ariaKey: "linkedinAria" },
  { href: "https://github.com/YOUBCH", Icon: FaGithub, ariaKey: "githubAria" },
  { href: "https://www.instagram.com/youssef.bachaoui.dev", Icon: FaInstagram, ariaKey: "instagramAria" },
] as const;

function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="section-inner footer-inner">
        <div className="footer-socials">
          {SOCIAL_LINKS.map(({ href, Icon, ariaKey }) => (
            <a key={href} href={href} target="_blank" rel="noreferrer" aria-label={t(`footer.${ariaKey}`)}>
              <Icon size={16} />
            </a>
          ))}
          <a href="mailto:bachaouiyoussef02@gmail.com" aria-label={t("footer.emailAria")}>
            <Mail size={16} />
          </a>
        </div>
        <div className="footer-text">
          <span>{t("footer.copyright", { year })}</span>
          <span>{t("footer.vat")}</span>
          <a href="https://github.com/YOUBCH/MyPortfolio" className="footer-credit">
            {t("footer.credit")}
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
